import { WithNavigationFrame } from '~/components/404';

export default WithNavigationFrame;
